import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import MaterialSpinner from "../../../ui/materialSpinner";
import {getRoomLayouts} from "../../lookNavigation/lookFunctions";
import GroheLayoutItem from "./groheLayoutItem";
import {useFeaturesRoomLayoutsChecker} from "../../../../actions/asyncActionFunctions";

const GroheRoomLayoutsContent = (props) => {

  const {visualizersLoadedLength} = props;
  const [looks, setLooks] = useState([]); // {lookLayout, lookScene}

  const featuresLoaded = useFeaturesRoomLayoutsChecker();

  useEffect(() => {
    if (featuresLoaded) {
      setLooks(getRoomLayouts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresLoaded])

  if (!featuresLoaded || !visualizersLoadedLength) {
    return (
      <div className="grohe-section__content grohe-section__content--no-scroll">
        <MaterialSpinner/>
      </div>
    )
  }

  return (
    // <div className="grohe-section__content grohe-section__content--no-scroll">
    //   <GroheRoomLayoutsVirtualizedList renderList={looks}/>
    // </div>
    <div className="grohe-section__content grohe-section__content--with-padding">
      <ul className="grohe-rooms">
        {looks.map((look, lookIndex) => {
          return <GroheLayoutItem look={look} key={lookIndex}/>
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, allFeaturesWereLoaded} = store.serverState;
  return {
    allFeaturesWereLoaded,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(GroheRoomLayoutsContent)
